import { useBindCx } from "@scalar/use-hooks/useBindCx";
import { createElementBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, renderSlot, unref } from "vue";
var ScalarSidebar_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	inheritAttrs: false,
	__name: "ScalarSidebar",
	setup(__props) {
		const { cx } = useBindCx();
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("aside", normalizeProps(guardReactiveProps(unref(cx)("flex flex-col border-r bg-sidebar-b-1 border-sidebar-border w-72"))), [renderSlot(_ctx.$slots, "default")], 16);
		};
	}
});
//#endregion
export { ScalarSidebar_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ScalarSidebar.vue.script.js.map